export const isUnlimited = (limit: number | undefined | null): boolean => {
  return limit === -1 || limit === Infinity;
};

export const getRemainingCount = (
  limit: number | undefined | null,
  usage: number
): number | 'Unlimited' => {
  if (limit === undefined || limit === null || isUnlimited(limit)) {
    return 'Unlimited';
  }
  return Math.max(0, limit - usage);
};

export const hasGenerationCapacity = (limit: number | undefined | null, usage: number): boolean => {
  const remaining = getRemainingCount(limit, usage);
  return remaining === 'Unlimited' || remaining > 0;
};

export const getCombinedRemaining = (
  limitsWithUsage: { limit: number | undefined | null; usage: number }[]
): number | 'Unlimited' => {
  let combinedRemaining: number | 'Unlimited' = 'Unlimited';

  for (const { limit, usage } of limitsWithUsage) {
    if (limit !== undefined && limit !== null && !isUnlimited(limit)) {
      const rem = Math.max(0, limit - usage);
      if (combinedRemaining === 'Unlimited') {
        combinedRemaining = rem;
      } else {
        combinedRemaining = Math.min(combinedRemaining, rem);
      }
    }
  }

  return combinedRemaining;
};

export const isCombinedLimitReached = (
  limitsWithUsage: { limit: number | undefined | null; usage: number }[]
): boolean => {
  const remaining = getCombinedRemaining(limitsWithUsage);
  return remaining !== 'Unlimited' && remaining <= 0;
};
